import { ThemeOverlay } from "./palette.types";

export const OVERLAY_FFFFFF: ThemeOverlay = {
    2: "#FFFFFF05",
    4: "#FFFFFF0A",
    8: "#FFFFFF14",
    12: "#FFFFFF1F",
    20: "#FFFFFF33",
    40: "#FFFFFF66",
    60: "#FFFFFF99",
    80: "#FFFFFFCC",
};

export const OVERLAY_F7F7F7: ThemeOverlay = {
    2: "#F7F7F705",
    4: "#F7F7F70A",
    8: "#F7F7F714",
    12: "#F7F7F71F",
    20: "#F7F7F733",
    40: "#F7F7F766",
    60: "#F7F7F799",
    80: "#F7F7F7CC",
};

export const OVERLAY_A7A7A7: ThemeOverlay = {
    2: "#A7A7A705",
    4: "#A7A7A70A",
    8: "#A7A7A714",
    12: "#A7A7A71F",
    20: "#A7A7A733",
    40: "#A7A7A766",
    60: "#A7A7A799",
    80: "#A7A7A7CC",
};

export const OVERLAY_8C8C8C: ThemeOverlay = {
    2: "#8C8C8C05",
    4: "#8C8C8C0A",
    8: "#8C8C8C14",
    12: "#8C8C8C1F",
    20: "#8C8C8C33",
    40: "#8C8C8C66",
    60: "#8C8C8C99",
    80: "#8C8C8CCC",
};

export const OVERLAY_4F4F4F: ThemeOverlay = {
    2: "#4F4F4F05",
    4: "#4F4F4F0A",
    8: "#4F4F4F14",
    12: "#4F4F4F1F",
    20: "#4F4F4F33",
    40: "#4F4F4F66",
    60: "#4F4F4F99",
    80: "#4F4F4FCC",
};

export const OVERLAY_292730: ThemeOverlay = {
    2: "#29273005",
    4: "#2927300A",
    8: "#29273014",
    12: "#2927301F",
    20: "#29273033",
    40: "#29273066",
    60: "#29273099",
    80: "#292730CC",
};
